import { WIDE_TABLET_WIDTH } from "hooks/useDeviceType";
import { useMediaQuery } from "usehooks-ts";
import { IGif } from "services/types";
import { useLocation } from "react-router";
import { getMoreMenuData } from "./menus";
import { useVisitorInfo } from "hooks";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { IAppState } from "store/app-state";
import { Roles } from "components/dialogs/EditNichesDialog/hooks";
import { MoreMenu } from "./MoreMenu";
import { PopoverOrigin } from "@mui/material";
import fscreen from "fscreen";

interface IMoreMenuContainerProps {
  gif: IGif;
  anchorEl: HTMLElement | null;
  handleCloseMenu: () => void;
  fullscreen?: boolean;
  handleHideGif: (gif: IGif) => void;
  handleManageClick: (gif: IGif) => void;
  handleOpenEditNichesDialog: (role: Roles) => void;
  toggleCollection: () => void;
  toggleNiche: (gif: string) => void;
  toggleReport: () => void;
  toggleShareMenu: (event: React.MouseEvent<HTMLButtonElement>) => void;
  toggleGifPrefs: () => void;
}

export const MoreMenuContainer: React.FC<IMoreMenuContainerProps> = (props) => {
  const {
    gif,
    anchorEl,
    handleCloseMenu,
    fullscreen,
    handleHideGif,
    handleManageClick,
    handleOpenEditNichesDialog,
    toggleCollection,
    toggleNiche,
    toggleReport,
    toggleShareMenu,
    toggleGifPrefs
  } = props;

  const isDesktop = useMediaQuery(`(min-width: ${WIDE_TABLET_WIDTH}px)`);
  const myNiches = useSelector((state: IAppState) => state.user.myNiches);
  const currentUser = useVisitorInfo();

  const location = useLocation();

  const isNicheContentModerator = useMemo(() => {
    const pathNameSplit = location.pathname.split("/");
    const nicheId = pathNameSplit.pop();
    const pageName = pathNameSplit.pop();
    let isModerator = false;

    if (pageName !== "niches") {
      return isModerator;
    }

    myNiches.forEach(({ id }) => {
      if (id === nicheId) {
        isModerator = true;
      }
    });

    return isModerator;
  }, [location, myNiches]);

  const actions = {
    handleHideGif,
    handleManageClick,
    handleOpenEditNichesDialog,
    toggleCollection,
    toggleNiche,
    toggleReport,
    toggleShareMenu,
    toggleGifPrefs,
  };

  const moreMenuData = getMoreMenuData({
    actions,
    currentUser,
    gif: gif,
    isNicheContentModerator,
  });

  const isFullscreenActive = fscreen.fullscreenElement;

  const menuProps = {
    anchorEl,
    anchorOrigin: {
      vertical: "center",
      horizontal: isDesktop && !isFullscreenActive ? "right" : "left",
    } as PopoverOrigin,
    transformOrigin: {
      vertical: "center",
      horizontal: isDesktop && !isFullscreenActive ? "left" : "right",
    } as PopoverOrigin,
    open: true,
    container: isFullscreenActive || undefined
  };

  return (
    <MoreMenu
      isOpen
      menuProps={menuProps}
      onClose={handleCloseMenu}
      menuItems={moreMenuData}
      isFullscreen={fullscreen}
    />
  );
};
